<template>
  <transition name="fade">
    <div
      :class="['project-popup-content', popupTop ? 'project-popup-content--top' : '']"
      ref="popupInfo"
    >
      <h3>Project Information</h3>

      <div class="project-popup-content__row">
        <p class="project-popup-content__item">Project name:</p>
        <p class="project-popup-content__item">{{ value.ProjectName }}</p>
      </div>

      <div class="project-popup-content__row" v-if="value.IndustryFieldsJson.length > 0">
        <p class="project-popup-content__item">Industry sector:</p>
        <p class="project-popup-content__item">
          <ul>
            <li v-for="item in value.IndustryFieldsJson" :key="item.ID">{{ item.Name }}</li>
          </ul>
        </p>
      </div>

      <div class="project-popup-content__row" v-if="value.DocumentTypesJson.length > 0">
        <p class="project-popup-content__item">Document type:</p>
        <p class="project-popup-content__item">
          <ul>
            <li v-for="item in value.DocumentTypesJson" :key="item.ID">{{ item.Name }}</li>
          </ul>
        </p>
      </div>

      <div class="project-popup-content__row">
        <p class="project-popup-content__item">QA model:</p>
        <p class="project-popup-content__item">{{ value.QaModel }}</p>
      </div>

      <div class="project-popup-content__row">
        <p class="project-popup-content__item">Evaluation method:</p>
        <p class="project-popup-content__item">{{ value.EVMethodData.Name }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'popupInfo',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      popupTop: false,
    };
  },
  mounted() {
    this.changePopupInfo();
  },
  methods: {
    changePopupInfo() {
      const topHeight = this.$refs.popupInfo.getBoundingClientRect().y;
      const space =
          window.innerHeight - topHeight - this.$refs.popupInfo.offsetHeight;

      if (space < 0) {
        this.popupTop = true;
      }
    },
  },
});
</script>
